const mapLayers = {
  options: {
    layers: 'Ebenen',
    ev: 'EV',
    bookings: 'Buchungen',
    heatMap: 'Wärmekarte',
  },
  legend: {
    powerType: {
      slow: 'Langsam',
      fast: 'Schnell',
      turbo: 'Turbo',
    },

    availability: {
      available: 'Verfügbar',
      notAvailable: 'Nicht verfügbar',
      selected: 'Ausgewählt',
      broken: 'Gebrochen',
      unknown: 'Unbekannt',
    },
  },
};

export default mapLayers;
